import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();

export const useKycStore = defineStore("kyc", {
    state: () => {
        return {
            loadings: false,
            steps: false,
            reasons: false,
            verifieds: ''
        };
    },

    getters: {
        loading: (state) => state.loadings,
        step: (state) => state.steps,
        reason: (state) => state.reasons,
        verified: (state) => state.verifieds,
    },

    actions: {
        postImages(data) {
            this.loadings = true;
            return new Promise((resolve, reject) => {
                axios.patch(useRuntimeConfig().public.apiBase + 'profile/image', data, {
                    headers: {
                        usertoken: localStorage.token,
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(() => {
                    this.loadings = false
                    resolve()
                }).catch(() => {
                    this.loadings = false
                    reject()
                })
            });
        },
    },
});